export function randomColor(index) {
  const hue = ((index * 256 * 15) / 22) % 256
  return `hsl(${hue}, 100%, 40%)`
}

export function loadScript(src) {
  return new Promise(function(resolve) {
    const s = document.createElement('script')
    s.src = src
    s.async = true
    s.defer = true
    s.crossorigin = 'anonymous'
    s.onload = resolve
    document.head.appendChild(s)
  })
}

export function refParam(url) {
  return url + (url.indexOf('?') > 0 ? '&' : '?') + 'giftfinder=1'
}

export function envReplace(url) {
  url = url || ''
  if (url.indexOf('http')) {
    url = 'https://' + url
  }
  if (typeof window === 'undefined') {
    return url
  }
  const host = window.location.host
  if (
    host.indexOf('dream') === 0 ||
    host.indexOf('local') === 0 ||
    host.indexOf('test.') === 0
  ) {
    return url.replace('dl.test.', 'www.').replace('dl.syst.', 'www.')
  }
  return url.replace('dl.test.', 'dl.syst.')
}

// if (/(MSIE |Trident.*rv[ :])([0-9]+)/.test(navigator.userAgent)) {
//   document.documentElement.className += ' ie '
// }

export function uniq(v, i, a) {
  return a.findIndex(b => b === v) === i
}

export function removeEmoji(string) {
  return string.replace(
    /([♀️♂️|\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
    ''
  )
}
